import PlayerIconAbstract from '../images/PlayerIconAbstract.png';

export default function PlayerIcon({image, fullName, playerFollowing, showPlayerFollowing = true , opacity='opacity-85', size="disc-7"}) {

    const imageLoadError = (e) => {
        e.target.src = PlayerIconAbstract;
        e.target.classList.add('border-10');
        e.target.classList.remove('border-4');
    };

    return (
        <div className={`${showPlayerFollowing ? 'position-relative' : ''}`}>
            <img className={`border border-4 border-white rounded-4 object-fit-cover bg-white ${opacity} ${size}`} onError={imageLoadError} src={image ?? ''} alt={fullName} />
            {(playerFollowing && showPlayerFollowing) ? 
                <div
                    className='position-absolute extra-extra-small extra-small-md rounded-3 bg-dark-mode-300 p-1half bottom-0 mb-n3 w-100 text-center fw-semi-bold'
                    style={{ '--bs-bg-opacity': 0.8 }}
                >Following</div>
                : <></>
            }
        </div>
    );
}
